import * as React from 'react';
import {
  styled,
  Grid,
  Typography,
  Card,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Divider,
  Box
} from '@mui/material';
import { useEffect, useState } from 'react';
import { api } from '../../api';
import ReactApexCharts from 'react-apexcharts';
import ChartInOut from './ChartInOut';
import { Link } from 'react-router-dom';
import dayjs, { Dayjs } from 'dayjs';
// import ReactApexChart from 'react-apexcharts';

const defaultPhotoURL =
  'https://minimal-kit-react.vercel.app/static/mock-images/avatars/avatar_default.jpg';

interface InOut {
  person_id: number;
  company_id: number;
  status_id: number;
  person_type_id: number;
  gate_id?: number;
  area_id?: number;

  name: string;
  person_type: string;

  photo?: string;
  company: string;
  status: string;
  gate: string;
  area?: string;
  created_time: string;
}
const SummaryInOut = () => {
  const [summary, setSummary] = useState({
    total_in_out: 0,
    total_in: 0,
    total_out: 0,
    total_inplant_in_out: 0,
    total_inplant_in: 0,
    total_inplant_out: 0,
    total_ot: 0,
    total_ot_exchange: 0,
    total_ot_not_exchange: 0
  });
  const [inOutList, setInOutList] = useState<InOut[]>([]);

  useEffect(() => {
    api.get(`/summary`).then((res) => {
      const { data } = res;
      setSummary(data);
    });
    api.get(`in-out`, { params: { limit: 5 } }).then((res) => {
      const { data } = res;
      setInOutList(data);
    });
  }, []);

  return (
    <Container>
      {/* <PageHeader text="สรุปจำนวนคนเข้า - ออกพื้นที่" /> */}
      <Grid container spacing={4} px={2} sx={{ marginTop: '8px' }}>
        <Grid item lg={9}>
          <Grid container spacing={4}>
            <Grid
              item
              lg={6}
              sx={{
                '& .apexcharts-datalabel-value': {
                  color: '#373d3f',
                  fontSize: '30px',
                  fontWeight: '700'
                }
              }}
            >
              <Card
                sx={{
                  paddingY: 2,
                  paddingX: 3,
                  boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px'
                }}
              >
                <Typography variant="h6" mb={2}>
                  บุคคลเข้า-ออก ประจำวัน
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <ReactApexCharts
                    options={{
                      chart: { type: 'donut' },
                      legend: { show: true, position: 'bottom', horizontalAlign: 'center' },
                      dataLabels: { enabled: false },
                      labels: ['เข้า', 'ออก'],
                      tooltip: { enabled: true },
                      colors: ['#21AEEE', '#1784e6'],
                      fill: { colors: ['#21AEEE', '#1784e6'] },
                      states: {
                        hover: { filter: { type: 'darken', value: 0.5 } },
                        active: { filter: { type: 'none', value: 0 } }
                      },
                      stroke: { width: 0 },
                      plotOptions: {
                        pie: {
                          expandOnClick: false,
                          donut: {
                            size: '75%',
                            labels: {
                              show: true,
                              name: { show: false },
                              total: {
                                show: true,
                                showAlways: true,
                                formatter: function (w: { globals: { seriesTotals: any } }) {
                                  const totals = w.globals.seriesTotals;

                                  const result = totals.reduce((a: any, b: any) => a + b, 0);

                                  return result;
                                }
                              }
                            }
                          }
                        }
                      }
                    }}
                    series={[summary.total_in, summary.total_out]}
                    type="donut"
                  />
                </Box>
              </Card>
            </Grid>
            <Grid
              item
              lg={6}
              sx={{
                '& .apexcharts-datalabel-value': {
                  color: '#373d3f',
                  fontSize: '30px',
                  fontWeight: '700'
                }
              }}
            >
              <Card
                sx={{
                  paddingY: 2,
                  paddingX: 3,
                  boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px'
                }}
              >
                <Typography variant="h6" mb={2}>
                  บุคคลเข้า-ออก พื้นที่กระบวนการผลิต
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <ReactApexCharts
                    options={{
                      chart: { type: 'donut' },
                      legend: { show: true, position: 'bottom', horizontalAlign: 'center' },
                      dataLabels: { enabled: false },
                      labels: ['เข้า', 'ออก'],
                      tooltip: { enabled: true },
                      colors: ['#21AEEE', '#1784e6'],
                      fill: { colors: ['#21AEEE', '#1784e6'] },
                      states: {
                        hover: { filter: { type: 'darken', value: 0.5 } },
                        active: { filter: { type: 'none', value: 0 } }
                      },
                      stroke: { width: 0 },
                      plotOptions: {
                        pie: {
                          expandOnClick: false,
                          donut: {
                            size: '75%',
                            labels: {
                              show: true,
                              name: { show: false },
                              total: {
                                show: true,
                                showAlways: true,
                                formatter: function (w: { globals: { seriesTotals: any } }) {
                                  const totals = w.globals.seriesTotals;

                                  const result = totals.reduce((a: any, b: any) => a + b, 0);

                                  return result;
                                }
                              }
                            }
                          }
                        }
                      }
                    }}
                    series={[summary.total_inplant_in, summary.total_inplant_out]}
                    type="donut"
                  />
                </Box>
              </Card>
            </Grid>
            {/* <Grid
              item
              lg={4}
              sx={{
                '& .apexcharts-datalabel-value': {
                  color: '#373d3f',
                  fontSize: '30px',
                  fontWeight: '700'
                }
              }}
            >
              <Card
                sx={{
                  paddingY: 2,
                  paddingX: 3,
                  boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px'
                }}
              >
                <Typography variant="h6" mb={2}>
                  สรุปการแลกบัตรล่วงเวลา
                </Typography>
                <ReactApexCharts
                  options={{
                    chart: { type: 'donut' },
                    legend: { show: true, position: 'bottom', horizontalAlign: 'center' },
                    dataLabels: { enabled: false },
                    labels: ['แลกบัตรแล้ว', 'ยังไม่ได้แลกบัตร'],
                    tooltip: { enabled: true },
                    colors: ['#21AEEE', '#1784e6'],
                    fill: { colors: ['#21AEEE', '#1784e6'] },
                    states: {
                      hover: { filter: { type: 'darken', value: 0.5 } },
                      active: { filter: { type: 'none', value: 0 } }
                    },
                    stroke: { width: 0 },
                    plotOptions: {
                      pie: {
                        expandOnClick: false,
                        donut: {
                          size: '75%',
                          labels: {
                            show: true,
                            name: { show: false },
                            total: {
                              show: true,
                              showAlways: true,
                              formatter: function (w: { globals: { seriesTotals: any } }) {
                                const totals = w.globals.seriesTotals;

                                const result = totals.reduce((a: any, b: any) => a + b, 0);

                                return result;
                              }
                            }
                          }
                        }
                      }
                    }
                  }}
                  series={[summary.total_ot_exchange, summary.total_ot_not_exchange]}
                  type="donut"
                />
              </Card>
            </Grid> */}
            <Grid item lg={12}>
              <Card
                sx={{
                  paddingY: 2,
                  paddingX: 3,
                  boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px'
                }}
              >
                <ChartInOut
                  filterID={''}
                  filterName={''}
                  filterGateIDList={[]}
                  filterAreaIDList={[]}
                  filterCompanyIDList={[]}
                  filterPersonTypeIDList={[]}
                  filterScanTypes={''}
                  filterStartDate={null}
                  filterEndDate={null}
                />
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={3}>
          <Card
            sx={{
              paddingY: 2,
              paddingX: 1,
              height: '100%',
              boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px'
            }}
          >
            <Grid container pl={2} alignItems="center">
              <Grid item xs={8}>
                <Typography variant="h6">ข้อมูลการแลกบัตรล่าสุด</Typography>
              </Grid>
              <Grid item xs={4} sx={{ textAlign: 'right' }}>
                {/* <Typography sx={{ textAlign: "right" }} color="primary" variant="subtitle1" gutterBottom>ดูทั้งหมด</Typography> */}
                <Button component={Link} to={`/summary-in-out/table`} size="small">
                  ดูทั้งหมด
                </Button>
                {/* <Button variant="text">ดูทั้งหมด</Button> */}
              </Grid>
            </Grid>
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
              {inOutList.map((data, index) => {
                // const created_time = new Date(data.created_time);
                return [
                  <ListItem alignItems="flex-start" key={index}>
                    <ListItemAvatar>
                      <Avatar
                        alt={data.name ? data.name : ''}
                        src={data.photo ? data.photo : defaultPhotoURL}
                      />
                    </ListItemAvatar>
                    <ListItemText
                      primary={data.name}
                      secondary={
                        <React.Fragment>
                          <Typography
                            sx={{ display: 'inline' }}
                            component="span"
                            variant="body2"
                            color="text.primary"
                          >
                            {data.area}
                          </Typography>
                          {` — ${data.area_id ? 'แสกน' + data.status : 'แลกบัตร' + data.status} ${
                            data.gate
                          }`}
                          <Typography variant="caption" display="block" gutterBottom>
                            {dayjs(data.created_time).format('DD/MM/YYYY HH:mm:ss')}
                          </Typography>
                        </React.Fragment>
                      }
                    />
                  </ListItem>,
                  index != inOutList.length - 1 ? (
                    <Divider variant="inset" component="li" key={`Divider${index}`} />
                  ) : null
                ];
              })}
              {/* <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                </ListItemAvatar>
                <ListItemText
                  primary="นายชื่อจริง สมมุติ"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: 'inline' }}
                        component="span"
                        variant="body2"
                        color="text.primary"
                      >
                        GSP#5
                      </Typography>
                      {' — แสกนออก ประตูป้อมยาม GSP#5'}
                      <Typography variant="caption" display="block" gutterBottom>
                        15/10/2565 | 11:20:14
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem>

              <Divider variant="inset" component="li" />
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />
                </ListItemAvatar>
                <ListItemText
                  primary="นายชื่อจริง สมมุติ"
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: 'inline' }}
                        component="span"
                        variant="body2"
                        color="text.primary"
                      >
                        GSP#5
                      </Typography>
                      {' — แสกนเข้า ประตูป้อมยาม GSP#5'}
                      <Typography variant="caption" display="block" gutterBottom>
                        15/10/2565 | 11:15:14
                      </Typography>
                    </React.Fragment>
                  }
                />
              </ListItem> */}
            </List>
          </Card>
        </Grid>
      </Grid>
      {/* <Grid container spacing={10}>
        <Grid item lg={4}>
          <Paper>
            <Box sx={CardContainer}>
              <Typography variant="h6">Total</Typography>
              <Typography variant="h6" sx={{ textAlign: 'end' }}>
                {`${numberWithCommas(summary.total_in_out)} คน`}
              </Typography>
            </Box>
            <Box sx={{ backgroundColor: 'lightblue', height: 4 }}></Box>
          </Paper>
        </Grid>
        <Grid item lg={4}>
          <Paper>
            <Box sx={CardContainer}>
              <Typography variant="h6">In</Typography>
              <Typography variant="h6" sx={{ textAlign: 'end' }}>
                {`${numberWithCommas(summary.total_in)} คน`}
              </Typography>
            </Box>
            <Box sx={{ backgroundColor: 'lightblue', height: 4 }}></Box>
          </Paper>
        </Grid>
        <Grid item lg={4}>
          <Paper>
            <Box sx={CardContainer}>
              <Typography variant="h6">Out</Typography>
              <Typography variant="h6" sx={{ textAlign: 'end' }}>
                {`${numberWithCommas(summary.total_out)} คน`}
              </Typography>
            </Box>
            <Box sx={{ backgroundColor: 'lightblue', height: 4 }}></Box>
          </Paper>
        </Grid>
      </Grid> */}

      {/* <Typography variant="h6" py={2} mt={2}>
        บุคคลเข้า พื้นที่กระบวนการผลิต
      </Typography>
      <Grid container spacing={10}>
        <Grid item lg={4}>
          <Paper>
            <Box sx={CardContainer}>
              <Typography variant="h6">Total</Typography>
              <Typography variant="h6" sx={{ textAlign: 'end' }}>
                {`${numberWithCommas(summary.total_inplant_in_out)} คน`}
              </Typography>
            </Box>
            <Box sx={{ backgroundColor: 'lightblue', height: 4 }}></Box>
          </Paper>
        </Grid>
        <Grid item lg={4}>
          <Paper>
            <Box sx={CardContainer}>
              <Typography variant="h6">In</Typography>
              <Typography variant="h6" sx={{ textAlign: 'end' }}>
                {`${numberWithCommas(summary.total_inplant_in)} คน`}
              </Typography>
            </Box>
            <Box sx={{ backgroundColor: 'lightblue', height: 4 }}></Box>
          </Paper>
        </Grid>
        <Grid item lg={4}>
          <Paper>
            <Box sx={CardContainer}>
              <Typography variant="h6">Out</Typography>
              <Typography variant="h6" sx={{ textAlign: 'end' }}>
                {`${numberWithCommas(summary.total_inplant_out)} คน`}
              </Typography>
            </Box>
            <Box sx={{ backgroundColor: 'lightblue', height: 4 }}></Box>
          </Paper>
        </Grid>
      </Grid> */}

      {/* <Typography variant="h6" py={2} mt={2}>
        สรุปการแลกบัตรล่วงเวลา
      </Typography>
      <Grid container spacing={10}>
        <Grid item lg={4}>
          <Paper>
            <Box sx={CardContainer}>
              <Typography variant="h6">Total</Typography>
              <Typography variant="h6" sx={{ textAlign: 'end' }}>
                {`${numberWithCommas(summary.total_ot)} คน`}
              </Typography>
            </Box>
            <Box sx={{ backgroundColor: 'lightblue', height: 4 }}></Box>
          </Paper>
        </Grid>
        <Grid item lg={4}>
          <Paper>
            <Box sx={CardContainer}>
              <Typography variant="h6">แลกบัตรแล้ว</Typography>
              <Typography variant="h6" sx={{ textAlign: 'end' }}>
                {`${numberWithCommas(summary.total_ot_exchange)} คน`}
              </Typography>
            </Box>
            <Box sx={{ backgroundColor: 'lightblue', height: 4 }}></Box>
          </Paper>
        </Grid>
        <Grid item lg={4}>
          <Paper>
            <Box sx={CardContainer}>
              <Typography variant="h6">ยังไม่ได้แลกบัตร</Typography>
              <Typography variant="h6" sx={{ textAlign: 'end' }}>
                {`${numberWithCommas(summary.total_ot_not_exchange)} คน`}
              </Typography>
            </Box>
            <Box sx={{ backgroundColor: 'lightblue', height: 4 }}></Box>
          </Paper>
        </Grid>
      </Grid> */}
    </Container>
  );
};

export default SummaryInOut;

const Container = styled('div')`
  padding: 16px;
`;

const CardContainer = {
  p: 2,
  minHeight: 100,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between'
};
